import { FETCH_DELIVERY_DATES } from "./actionTypes";

const initialState = {
  deliveryDates: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DELIVERY_DATES:
      return {
        ...state,
        deliveryDates: action.payload,
      };
    default:
      return state;
  }
}